<template lang="pug">
div
  ods-sub-header(
    :is-absolute='false'
    :stretch='false').actionsCupons
    div.actionsLeft
      router-link(:to="{ name: namePathPrev, query: { activeTab: 'cupones' } }")
        ods-button(type="text" icon="ods-icon-arrow-left")
      p.glue {{ $t('loyalty.CouponsAsing', { alaplantilla: appProgramDescr }) }}
    div.actionsRight
      router-link(:to="{ name: namePathPrev, query: { activeTab: 'cupones' } }")
        ods-button(type="secondary" size="small") {{ $t('loyalty.prev') }}
      router-link(:to="{ name: namePathNext, query: { row: rowSelected } }" :is="rowSelected===null ? 'span' : 'router-link'")
        ods-button(type="primary" size="small" :disabled="rowSelected===null") {{ $t('loyalty.next') }}
  ods-module
    plantillas-table(@row-selected="rowSelectedTable")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PlantillasTable from '@/components/loyalty/Coupons/PlantillasTableAssig'
export default {
  name: 'CouponsAsing',
  data () {
    return {
      data: {},
      activar: 0,
      appProgramDescr: '',
      activeTab: 'general',
      pantallageneral: 'general',
      pantallaconfiguracion: 'configuracion',
      pantallaconversion: 'conversion',
      pantallacomercios: 'comercios',
      datosprincipales: true,
      configuracion: false,
      conversion: false,
      comercios: false,
      namePathPrev: 'LoyaltyCoupons',
      namePathNext: 'CouponsAsingAccounts',
      rowSelected: null
    }
  },
  components: {
    'plantillas-table': PlantillasTable
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang'
    })
  },
  async mounted () {
    this.appProgramDescr = sessionStorage.getItem('appProgramDescr')
  },
  methods: {
    ...mapActions([]),
    rowSelectedTable (row) {
      this.rowSelected = row
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>
